import { useCallback } from 'react';
import supabaseClient from '@/api/supabaseClient.ts';
import { getConsent } from '@/utils/trackingConsent';
import { getSessionId } from '@/utils/trackingSession';

export function useTracking() {
  const track = useCallback((eventName: string, eventData?: Record<string, unknown>) => {
    const consent = getConsent();
    const sessionId = getSessionId();

    supabaseClient.functions
      .invoke('track_event', {
        body: {
          event_name: eventName,
          event_data: eventData ?? {},
          session_id: sessionId,
          consent,
        },
      })
      .catch(() => {});
  }, []);

  return { track };
}
